import { useTheme, useMediaQuery } from "@mui/material";
import SmallScreenHero from "./small";
import LargeScreenHero from "./large";

const Hero = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return isSmallScreen ? ( 
    <SmallScreenHero/> 
  ) : (
    <LargeScreenHero/>
  );
};

export default Hero;
